













































import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import Card from '@/components/material/Card.vue';
import DlgPressNew from '@/modules/press/_components/DlgPressNew.vue';
import DlgPressDelete from '@/modules/press/_components/DlgPressDelete.vue';
import DlgPressEdit from '@/modules/press/_components/DlgPressEdit.vue';

@Component({
    components: {
      DlgPressEdit,
      Card,
      DlgPressNew,
      DlgPressDelete,
    },
  })
  export default class PressList extends Vue {
    private loading: boolean = false;
    private currentPress: any = {};
    private dlgEdit: boolean = false;

    private headers: any = [
      {
        text: 'Titel',
        align: 'left',
        value: 'title',
      },
      {
        text: 'Datum',
        name: 'date',
        align: 'left',
        value: 'pressDateParsed',
      },
      {
        text: '',
        align: 'left',
        sortable: false,
        value: '',
      },
    ];

    private pagination: any = {
      descending: true,
      page: 1,
      rowsPerPage: -1,
      sortBy: 'pressDateParsed',
    };

    private search: string = '';

    @Getter('press/all') private press!: any[];
    @Action('press/read') private readAllPress!: any;

    private created() {
      this.loading = true;
      this.readAllPress()
        .then(() => {
          this.loading = false;
        });
    }

    private edit(press: any) {
      this.currentPress = press;
      this.dlgEdit = true;
    }
  }
